import React from 'react';
import { Box, BoxProps, Button, RefreshIcon, Text } from '@razorpay/blade/components';
import { getStaticMediaUrl } from 'utils/Urls';
import failedToLoad from 'assets/network-error.svg';

export const ErrorView = ({
  onRefetch,
  children = null,
  ...boxProps
}: React.PropsWithChildren<
  {
    onRefetch?: () => void;
  } & BoxProps
>) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      borderRadius="medium"
      borderWidth="thin"
      borderColor="surface.border.gray.subtle"
      height="70vh"
      padding="spacing.6"
      backgroundColor="surface.background.gray.moderate"
      {...boxProps}>
      <img
        width="150px"
        height="150px"
        src={getStaticMediaUrl(failedToLoad)}
        alt="Failed to load"
      />
      <Text size="medium" color="surface.text.gray.muted" marginY="spacing.4">
        {'Uh Oh, Failed to load :('}
      </Text>
      {!!onRefetch && (
        <Button
          onClick={onRefetch}
          variant="primary"
          icon={RefreshIcon}
          iconPosition="left"
          size="small">
          Retry
        </Button>
      )}
      {children}
    </Box>
  );
};
